(function() {
    'use strict';

    angular
        .module('masterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reason-write-off', {
            url: '/reason-write-off',
            data: {
                pageTitle: 'Lý do xuất hàng'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=master/reason-write-off/reason-write-off',
                    controller: 'ReasonWriteOffController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('reason-write-off-detail', {
            url: '/reason-write-off/{id}',
            data: {
                pageTitle: 'Lý do xuất hàng'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=master/reason-write-off/reason-write-off-detail',
                    controller: 'ReasonWriteOffDetailController',
                    controllerAs: 'vm'
                }
            }
            ,
            resolve: {
                entity: ['$stateParams', 'ReasonWriteOff', function($stateParams, ReasonWriteOff) {
                    return ReasonWriteOff.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('reason-write-off.new', {
            /*url: '/new',*/
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: GLOBAL_URL+'partial?uri=master/reason-write-off/reason-write-off-dialog',
                    controller: 'ReasonWriteOffDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('reason-write-off', null, { reload: true });
                }, function() {
                    $state.go('reason-write-off');
                });
            }]
        })
        .state('reason-write-off.edit', {
            url: '/{id}/edit',
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: GLOBAL_URL+'partial?uri=master/reason-write-off/reason-write-off-dialog',
                    controller: 'ReasonWriteOffDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReasonWriteOff', function(ReasonWriteOff) {
                            return ReasonWriteOff.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reason-write-off', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reason-write-off.delete', {
            url: '/{id}/delete',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: GLOBAL_URL+'partial?uri=master/reason-write-off/reason-write-off-delete-dialog',
                    controller: 'ReasonWriteOffDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReasonWriteOff', function(ReasonWriteOff) {
                            return ReasonWriteOff.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reason-write-off', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
